export const RESET_SYSTEM_USERS = "RESET_SYSTEM_USERS";
export const RESET_SYSTEM_USER = "RESET_SYSTEM_USER";
export const RESET_ERROR = "RESET_ERROR";

export const GET_SYSTEM_USERS = "GET_SYSTEM_USERS";
export const SET_SYSTEM_USERS = "SET_SYSTEM_USERS";

export const API_ERROR = "SYSTEM_USERS_API_ERROR";

export const GET_SYSTEM_USER = "GET_SYSTEM_USER";
export const SET_SYSTEM_USER = "SET_SYSTEM_USER";

export const EDIT_SYSTEM_USER = "EDIT_SYSTEM_USER";
export const EDIT_SYSTEM_USER_SUCCESS = "EDIT_SYSTEM_USER_SUCCESS";

export const CREATE_SYSTEM_USER = "CREATE_SYSTEM_USER";
export const CREATE_SYSTEM_USER_SUCCESS = "CREATE_SYSTEM_USER_SUCCESS";

export const ACTIVATE_SYSTEM_USER = "ACTIVATE_SYSTEM_USER";
export const ACTIVATE_SYSTEM_USER_SUCCESS = "ACTIVATE_SYSTEM_USER_SUCCESS";
